import React, { useEffect, useState } from "react";
import IconsGen from "../../../icons_generator/IconsGen";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Loader from "../../../loader/Loader";
import AxiosController from "../../../authentication/AxiosController";
import { Helmet } from "react-helmet";
import DateRangePickerComponent from "../../../date/DateRangePickerComponent";
import { format } from "date-fns";
import { Form, Button, Table } from "react-bootstrap";

const FulfilllmentRepost = () => {
  const { slug, lang } = useParams();

  const [_] = useTranslation("global");
  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const token = localStorage.getItem("token");
  const [loading, handleLoader] = useState(false);
  const [data, setData] = useState({});
  const [overviewData, setOverviewData] = useState({});
  const [activeTab, setActiveTab] = useState("reports");
  const [fulfillmentId, setFulfillmentId] = useState("");
  const [selectedFulfillmentMerchant, setSelectedFulfillmentMerchant] =
    useState("");
  const [fulfillmentMerchants, setFulfillmentMerchants] = useState([]);
  const [datesSelected, setDatesSelected] = useState(false);

  const [state, setState] = useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  });

  const get_fulfillments = (dates = {}, fulfillment_id = "") => {
    const params = {};
    if (dates["start"]) params.start_date = dates["start"];
    if (dates["end"]) params.end_date = dates["end"];
    if (fulfillment_id) params.fulfillment_id = fulfillment_id;

    AxiosController.get(`api/${slug}/${lang}/fulfillments/reports`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params,
    })
      .then((res) => {
        setData(res.data);
        handleLoader(false);
      })
      .catch((e) => {
        handleLoader(false);
      });
  };

  const get_fulfillments_overview = (dates = {}, fulfillment_id = "") => {
    const params = {};
    if (dates["start"]) params.start_date = dates["start"];
    if (dates["end"]) params.end_date = dates["end"];
    if (fulfillment_id) params.fulfillment_id = fulfillment_id;

    AxiosController.get(`api/${slug}/${lang}/reports/fulfillments-overview`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params,
    })
      .then((res) => {
        // API returns: { fulfillments: [...] }
        const data = res.data || {};
        setOverviewData(data);
        handleLoader(false);
      })
      .catch((e) => {
        handleLoader(false);
      });
  };

  const get_fulfillment_merchants = () => {
    // Fetch all fulfillment merchants by requesting multiple pages if needed
    const fetchPage = (page = 1, allMerchants = []) => {
      AxiosController.get(`api/${slug}/${lang}/search/get-user/${page}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          role: "fulfillment",
        },
      })
        .then((res) => {
          // API returns: { users: { data: [...], last_page: ..., ... } }
          const usersData = res?.data?.users || res?.data;
          if (usersData && usersData.data && Array.isArray(usersData.data)) {
            const newMerchants = [...allMerchants, ...usersData.data];
            // If there are more pages, fetch them
            if (usersData.last_page && page < usersData.last_page) {
              fetchPage(page + 1, newMerchants);
            } else {
              setFulfillmentMerchants(newMerchants);
            }
          } else {
            setFulfillmentMerchants(allMerchants);
          }
        })
        .catch((e) => {
          console.error("Error fetching fulfillment merchants:", e);
          setFulfillmentMerchants(allMerchants);
        });
    };
    fetchPage();
  };
  useEffect(() => {
    get_fulfillment_merchants();
    get_fulfillments();
    get_fulfillments_overview();
  }, []);

  const applyDateRange = () => {
    const { startDate, endDate } = state.selection;
    const formattedStartDate = new Date(startDate.setHours(0, 0, 0, 0));
    const formattedEndDate = new Date(endDate.setHours(0, 0, 0, 0));

    // Format dates to YYYY-MM-DD for API
    const apiStartDate = format(formattedStartDate, "yyyy-MM-dd");
    const apiEndDate = format(formattedEndDate, "yyyy-MM-dd");

    setDatesSelected(true);
    handleLoader(true);
    get_fulfillments({ start: apiStartDate, end: apiEndDate }, fulfillmentId);
    get_fulfillments_overview(
      { start: apiStartDate, end: apiEndDate },
      fulfillmentId
    );
  };

  const handleSearch = () => {
    handleLoader(true);

    // Only send dates if they were explicitly selected by the user
    if (datesSelected) {
      const { startDate, endDate } = state.selection;
      const formattedStartDate = new Date(startDate.setHours(0, 0, 0, 0));
      const formattedEndDate = new Date(endDate.setHours(0, 0, 0, 0));

      const apiStartDate = format(formattedStartDate, "yyyy-MM-dd");
      const apiEndDate = format(formattedEndDate, "yyyy-MM-dd");

      get_fulfillments({ start: apiStartDate, end: apiEndDate }, fulfillmentId);
      get_fulfillments_overview(
        { start: apiStartDate, end: apiEndDate },
        fulfillmentId
      );
    } else {
      // Search without dates
      get_fulfillments({}, fulfillmentId);
      get_fulfillments_overview({}, fulfillmentId);
    }
  };

  const handleReset = () => {
    setFulfillmentId("");
    setSelectedFulfillmentMerchant("");
    setDatesSelected(false);
    setState({
      selection: {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    });
    handleLoader(true);
    get_fulfillments();
    get_fulfillments_overview();
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "overview" && Object.keys(overviewData).length === 0) {
      handleLoader(true);
      // Only send dates if they were explicitly selected by the user
      if (datesSelected) {
        const { startDate, endDate } = state.selection;
        const formattedStartDate = new Date(startDate.setHours(0, 0, 0, 0));
        const formattedEndDate = new Date(endDate.setHours(0, 0, 0, 0));
        const apiStartDate = format(formattedStartDate, "yyyy-MM-dd");
        const apiEndDate = format(formattedEndDate, "yyyy-MM-dd");
        get_fulfillments_overview(
          { start: apiStartDate, end: apiEndDate },
          fulfillmentId
        );
      } else {
        get_fulfillments_overview({}, fulfillmentId);
      }
    }
  };

  return (
    <div className="flex-grow-1 stats-component">
      <Helmet>
        <title>{_("panel.fulfillmentReport")}</title>
      </Helmet>
      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative ">
        <Loader active={loading} />
        <div className="reports-header d-flex flex-column flex-md-row py-2 justify-content-between flex-wrap">
          <h3 style={{ color: "rgba(23, 43, 77, 1)" }}>
            {_("panel.fulfillmentReport")}
          </h3>
        </div>

        {/* Search Form */}
        <div className="search-form-container mb-3 p-3 border rounded">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSearch();
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "1rem",
                alignItems: "end",
              }}
            >
              <Form.Group>
                <Form.Label>رقم الفولفمنت</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="رقم الفولفمنت"
                  value={fulfillmentId}
                  onChange={(e) => setFulfillmentId(e.target.value)}
                />
              </Form.Group>
              <div>
                <DateRangePickerComponent
                  state={state}
                  setState={setState}
                  applyDateRange={() => applyDateRange()}
                />
              </div>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                <Button
                  style={{
                    backgroundColor: "rgb(89, 198, 201)",
                    border: "none",
                    borderRadius: "7px",
                    flex: 1,
                  }}
                  type="submit"
                  variant="primary"
                >
                  {_("panel.search") || "بحث"}
                </Button>
                <Button
                  type="button"
                  variant="secondary"
                  style={{ flex: 1 }}
                  onClick={handleReset}
                >
                  {_("panel.reset") || "إعادة تعيين"}
                </Button>
              </div>
            </div>
          </Form>
        </div>

        {/* Tab Navigation */}
        <div className="tab-navigation d-flex gap-2 mb-3">
          <button
            className={`tab-button px-3 py-2 border-0 rounded ${
              activeTab === "reports" ? "active" : ""
            }`}
            onClick={() => handleTabChange("reports")}
            style={{
              backgroundColor:
                activeTab === "reports" ? "#172b4d" : "transparent",
              color: activeTab === "reports" ? "white" : "#172b4d",
              border: "1px solid #172b4d",
              cursor: "pointer",
            }}
          >
            {_("panel.reports")}
          </button>
          <button
            className={`tab-button px-3 py-2 border-0 rounded ${
              activeTab === "overview" ? "active" : ""
            }`}
            onClick={() => handleTabChange("overview")}
            style={{
              backgroundColor:
                activeTab === "overview" ? "#172b4d" : "transparent",
              color: activeTab === "overview" ? "white" : "#172b4d",
              border: "1px solid #172b4d",
              cursor: "pointer",
            }}
          >
            {_("panel.overview")}
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === "reports" && (
          <div
            className="boxes-container d-flex flex-wrap gap-2"
            dir={box_head_dir}
          >
            <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
              <div className="top d-flex align-items-center gap-2">
                <IconsGen icon_name={"dollarSign"} />
                <p className="flex-grow-1">
                  {_("panel.total_confirmation_cost")}
                </p>
              </div>
              <div className="middle fs-2">
                <p>
                  {Number(data["total_confirmation_price"]).toLocaleString() ||
                    0}
                </p>
                <small className="text-muted d-block">
                  عدد الطلبات:{" "}
                  {Number(
                    data["confirmation_orders_count"] || 0
                  ).toLocaleString()}
                </small>
              </div>
            </div>
            <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
              <div className="top d-flex align-items-center gap-2">
                <IconsGen icon_name={"bluecheck"} />
                <p className="flex-grow-1">{_("panel.cancellation_cost")}</p>
              </div>
              <div className="middle fs-2">
                <p>
                  {Number(data["total_cancellation_price"]).toLocaleString() ||
                    0}
                </p>
                <small className="text-muted d-block">
                  عدد الطلبات:{" "}
                  {Number(
                    data["cancellation_orders_count"] || 0
                  ).toLocaleString()}
                </small>
              </div>
            </div>
            <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
              <div className="top d-flex align-items-center gap-2">
                <IconsGen icon_name={"bluetrans"} />

                <p className="flex-grow-1">{_("panel.handling_cost")}</p>
              </div>
              <div className="middle fs-2">
                <p>
                  {Number(data["total_fulfillment_price"]).toLocaleString() ||
                    0}
                </p>
                <small className="text-muted d-block">
                  عدد الطلبات:{" "}
                  {Number(
                    data["fulfillment_orders_count"] || 0
                  ).toLocaleString()}
                </small>
              </div>
            </div>
            {/* <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
            <div className="top d-flex align-items-center gap-2">
              <IconsGen icon_name={"orangdash"} />

              <p className="flex-grow-1"  >
                {_("panel.order_value")}
              </p>
            </div>
            <div className="middle fs-2">
              <p>
                {Number(data["total_expected_money"]).toLocaleString() || 0}
              </p>
            </div>
          </div> */}
            <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
              <div className="top d-flex align-items-center gap-2">
                <IconsGen icon_name={"orangdash"} />

                <p className="flex-grow-1">{_("home.shippingcost")}</p>
              </div>
              <div className="middle fs-2">
                <p>
                  {Number(data["total_shipping_cost"]).toLocaleString() || 0}
                </p>
                <small className="text-muted d-block">
                  عدد الطلبات:{" "}
                  {Number(data["shipping_orders_count"] || 0).toLocaleString()}
                </small>
              </div>
            </div>
            <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
              <div className="top d-flex align-items-center gap-2">
                <IconsGen icon_name={"orangdash"} />

                <p className="flex-grow-1">{_("panel.post_delivery_charge")}</p>
              </div>
              <div className="middle fs-2">
                <p>
                  {Number(data?.post_delivery_charge || 0).toLocaleString()}
                </p>
                <small className="text-muted d-block">
                  عدد الطلبات:{" "}
                  {Number(
                    data["post_delivery_orders_count"] || 0
                  ).toLocaleString()}
                </small>
              </div>
            </div>
            <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
              <div className="top d-flex align-items-center gap-2">
                <IconsGen icon_name={"orangdash"} />

                <p className="flex-grow-1">اجمالي تكاليف الخدمات</p>
              </div>
              <p className="middle fs-2">
                {Number(data?.total_confirmation_price) +
                  Number(data?.total_cancellation_price) +
                  Number(data?.total_fulfillment_price) +
                  Number(data?.total_shipping_cost) +
                  Number(data?.post_delivery_charge)}
              </p>
              <p className="text-muted d-block">
                عدد الطلبات: {Number(data?.shipping_orders_count) || 0}
              </p>
            </div>
            <div
              className="report-box col-5 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify"
              style={{ background: "none" }}
            ></div>
            <div
              className="report-box col-5 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify"
              style={{ background: "none" }}
            ></div>
          </div>
        )}

        {activeTab === "overview" && (
          <div className="overview-container">
            {/* Summary Statistics */}
            <div
              className="boxes-container d-flex flex-wrap gap-2 mb-4"
              dir={box_head_dir}
            >
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"dollarSign"} />
                  <p className="flex-grow-1">{_("panel.total_fulfillments")}</p>
                </div>
                <div className="middle fs-2">
                  <p>{overviewData?.fulfillments?.length || 0}</p>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"bluecheck"} />
                  <p className="flex-grow-1">عدد الطلبات</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {overviewData?.fulfillments?.reduce(
                      (sum, item) => sum + parseInt(item.orders_count || 0),
                      0
                    ) || 0}
                  </p>
                  <small className="text-muted d-block">
                    الكمية:{" "}
                    {overviewData?.fulfillments?.reduce(
                      (sum, item) => sum + parseInt(item.total_quantity || 0),
                      0
                    ) || 0}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />
                  <p className="flex-grow-1">{_("panel.total_sales")}</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {overviewData?.fulfillments
                      ?.reduce(
                        (sum, item) => sum + parseFloat(item.total_sales || 0),
                        0
                      )
                      .toLocaleString() || 0}
                  </p>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />
                  <p className="flex-grow-1">اجمالي دخل التاجر</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {overviewData?.fulfillments
                      ?.reduce(
                        (sum, item) => sum + parseFloat(item.net_money || 0),
                        0
                      )
                      .toLocaleString() || 0}
                  </p>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"dollarSign"} />
                  <p className="flex-grow-1">{_("panel.confirmation_price")}</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {overviewData?.fulfillments
                      ?.reduce(
                        (sum, item) =>
                          sum + parseFloat(item.confirmation_price || 0),
                        0
                      )
                      .toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {overviewData?.fulfillments?.reduce(
                      (sum, item) =>
                        sum + parseInt(item.confirmation_orders_count || 0),
                      0
                    ) || 0}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"bluecheck"} />
                  <p className="flex-grow-1">{_("panel.cancellation_price")}</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {overviewData?.fulfillments
                      ?.reduce(
                        (sum, item) =>
                          sum + parseFloat(item.cancellation_price || 0),
                        0
                      )
                      .toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {overviewData?.fulfillments?.reduce(
                      (sum, item) =>
                        sum + parseInt(item.cancellation_orders_count || 0),
                      0
                    ) || 0}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"bluetrans"} />
                  <p className="flex-grow-1">{_("panel.fulfillment_price")}</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {overviewData?.fulfillments
                      ?.reduce(
                        (sum, item) =>
                          sum + parseFloat(item.fulfillment_price || 0),
                        0
                      )
                      .toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {overviewData?.fulfillments?.reduce(
                      (sum, item) =>
                        sum + parseInt(item.fulfillment_orders_count || 0),
                      0
                    ) || 0}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />
                  <p className="flex-grow-1">تكاليف الشحن</p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {overviewData?.fulfillments
                      ?.reduce(
                        (sum, item) =>
                          sum + parseFloat(item.shipping_cost || 0),
                        0
                      )
                      .toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {overviewData?.fulfillments?.reduce(
                      (sum, item) =>
                        sum + parseInt(item.shipping_orders_count || 0),
                      0
                    ) || 0}
                  </small>
                </div>
              </div>
              <div className="report-box col-12 col-lg-3 d-flex flex-column gap-2 flex-grow-1 align-items-center py-3 orangify">
                <div className="top d-flex align-items-center gap-2">
                  <IconsGen icon_name={"orangdash"} />
                  <p className="flex-grow-1">
                    {_("panel.post_delivery_charge")}
                  </p>
                </div>
                <div className="middle fs-2">
                  <p>
                    {overviewData?.fulfillments
                      ?.reduce(
                        (sum, item) =>
                          sum + parseFloat(item.post_delivery_charge || 0),
                        0
                      )
                      .toLocaleString() || 0}
                  </p>
                  <small className="text-muted d-block">
                    عدد الطلبات:{" "}
                    {overviewData?.fulfillments?.reduce(
                      (sum, item) =>
                        sum + parseInt(item.post_delivery_orders_count || 0),
                      0
                    ) || 0}
                  </small>
                </div>
              </div>
            </div>

            {/* Fulfillment Records Table */}
            {overviewData?.fulfillments &&
              overviewData.fulfillments.length > 0 && (
                <div className="fulfillment-records">
                  <h5 className="mb-3" style={{ color: "rgba(23, 43, 77, 1)" }}>
                    {_("panel.fulfillment_records")}
                  </h5>
                  <div className="row">
                    <div
                      className="col-lg-12 gy-4"
                      style={{ position: "relative", overflowX: "auto" }}
                    >
                      <Table
                        responsive
                        dir={box_head_dir}
                        className="reports-table text-nowrap text-center"
                      >
                        <thead>
                          <tr className="text-center">
                            <th>{_("panel.name")}</th>
                            <th>عدد الطلبات</th>
                            <th>الكمية</th>
                            <th>الطلبات التي تم شحنها</th>
                            <th>{_("panel.total_sales")}</th>
                            <th>
                              تكاليف الشحن
                              <br />
                              <small className="text-xs">(عدد الطلبات)</small>
                            </th>
                            <th>
                              {_("panel.confirmation_price")}
                              <br />
                              <small className="text-xs">(عدد الطلبات)</small>
                            </th>
                            <th>
                              {_("panel.fulfillment_price")}
                              <br />
                              <small className="text-xs">(عدد الطلبات)</small>
                            </th>
                            <th>
                              {_("panel.cancellation_price")}
                              <br />
                              <small className="text-xs">(عدد الطلبات)</small>
                            </th>
                            <th>
                              {_("panel.post_delivery_charge")}
                              <br />
                              <small className="text-xs">(عدد الطلبات)</small>
                            </th>
                            <th className="text-center">
                              إجمالي تكاليف الخدمات <br />{" "}
                              <span className="text-xs">
                                {" "}
                                ( تاكيد + هندلينج + الغاء + شحن + ما بعد التسليم
                                )
                              </span>
                            </th>
                            <th>اجمالي دخل التاجر </th>
                            <th>اجمالي تم سحبه</th>
                            <th>ماليات مستحقة</th>
                          </tr>
                        </thead>
                        <tbody>
                          {overviewData.fulfillments.map(
                            (fulfillment, index) => {
                              const totalRevenue =
                                parseFloat(
                                  fulfillment.confirmation_price || 0
                                ) +
                                parseFloat(fulfillment.fulfillment_price || 0) +
                                parseFloat(
                                  fulfillment.cancellation_price || 0
                                ) +
                                parseFloat(
                                  fulfillment.post_delivery_charge || 0
                                ) +
                                parseFloat(fulfillment.shipping_cost || 0);

                              return (
                                <tr
                                  key={fulfillment.fulfillment_id || index}
                                  className="text-center"
                                >
                                  <td>
                                    <span className="fw-bold">
                                      ID : {fulfillment.fulfillment_id}
                                    </span>
                                    <br />
                                    {`${fulfillment.fulfillment_first_name} ${fulfillment.fulfillment_last_name}`}
                                  </td>
                                  <td>{fulfillment.orders_count || 0}</td>
                                  <td>{fulfillment.total_quantity || 0}</td>
                                  <td>
                                    {fulfillment.shipped_orders_count || 0}
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.total_sales || 0
                                    ).toLocaleString()}
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.shipping_cost || 0
                                    ).toLocaleString()}
                                    <br />
                                    <small className="text-muted">
                                      ({fulfillment.shipping_orders_count || 0})
                                    </small>
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.confirmation_price || 0
                                    ).toLocaleString()}
                                    <br />
                                    <small className="text-muted">
                                      (
                                      {fulfillment.confirmation_orders_count ||
                                        0}
                                      )
                                    </small>
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.fulfillment_price || 0
                                    ).toLocaleString()}
                                    <br />
                                    <small className="text-muted">
                                      (
                                      {fulfillment.fulfillment_orders_count ||
                                        0}
                                      )
                                    </small>
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.cancellation_price || 0
                                    ).toLocaleString()}
                                    <br />
                                    <small className="text-muted">
                                      (
                                      {fulfillment.cancellation_orders_count ||
                                        0}
                                      )
                                    </small>
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.post_delivery_charge || 0
                                    ).toLocaleString()}
                                    <br />
                                    <small className="text-muted">
                                      (
                                      {fulfillment.post_delivery_orders_count ||
                                        0}
                                      )
                                    </small>
                                  </td>
                                  <td>
                                    {Number(totalRevenue).toLocaleString()}
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.net_money || 0
                                    ).toLocaleString()}
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.total_withdrawn || 0
                                    ).toLocaleString()}
                                  </td>
                                  <td>
                                    {Number(
                                      fulfillment.wallet_balance || 0
                                    ).toLocaleString()}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                          {overviewData.fulfillments &&
                            overviewData.fulfillments.length > 0 && (
                              <tr className="table-info fw-bold text-center">
                                <td>الإجمالي</td>
                                <td>
                                  {overviewData.fulfillments.reduce(
                                    (sum, item) =>
                                      sum + parseInt(item.orders_count || 0),
                                    0
                                  )}
                                </td>
                                <td>
                                  {overviewData.fulfillments.reduce(
                                    (sum, item) =>
                                      sum + parseInt(item.total_quantity || 0),
                                    0
                                  )}
                                </td>
                                <td>
                                  {overviewData.fulfillments.reduce(
                                    (sum, item) =>
                                      sum +
                                      parseInt(item.shipped_orders_count || 0),
                                    0
                                  )}
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum + parseFloat(item.total_sales || 0),
                                      0
                                    )
                                    .toLocaleString()}
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(item.shipping_cost || 0),
                                      0
                                    )
                                    .toLocaleString()}
                                  <br />
                                  <small className="text-muted">
                                    (
                                    {overviewData.fulfillments.reduce(
                                      (sum, item) =>
                                        sum +
                                        parseInt(
                                          item.shipping_orders_count || 0
                                        ),
                                      0
                                    )}
                                    )
                                  </small>
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(
                                          item.confirmation_price || 0
                                        ),
                                      0
                                    )
                                    .toLocaleString()}
                                  <br />
                                  <small className="text-muted">
                                    (
                                    {overviewData.fulfillments.reduce(
                                      (sum, item) =>
                                        sum +
                                        parseInt(
                                          item.confirmation_orders_count || 0
                                        ),
                                      0
                                    )}
                                    )
                                  </small>
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(item.fulfillment_price || 0),
                                      0
                                    )
                                    .toLocaleString()}
                                  <br />
                                  <small className="text-muted">
                                    (
                                    {overviewData.fulfillments.reduce(
                                      (sum, item) =>
                                        sum +
                                        parseInt(
                                          item.fulfillment_orders_count || 0
                                        ),
                                      0
                                    )}
                                    )
                                  </small>
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(
                                          item.cancellation_price || 0
                                        ),
                                      0
                                    )
                                    .toLocaleString()}
                                  <br />
                                  <small className="text-muted">
                                    (
                                    {overviewData.fulfillments.reduce(
                                      (sum, item) =>
                                        sum +
                                        parseInt(
                                          item.cancellation_orders_count || 0
                                        ),
                                      0
                                    )}
                                    )
                                  </small>
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(
                                          item.post_delivery_charge || 0
                                        ),
                                      0
                                    )
                                    .toLocaleString()}
                                  <br />
                                  <small className="text-muted">
                                    (
                                    {overviewData.fulfillments.reduce(
                                      (sum, item) =>
                                        sum +
                                        parseInt(
                                          item.post_delivery_orders_count || 0
                                        ),
                                      0
                                    )}
                                    )
                                  </small>
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(
                                          item.confirmation_price || 0
                                        ) +
                                        parseFloat(
                                          item.fulfillment_price || 0
                                        ) +
                                        parseFloat(
                                          item.cancellation_price || 0
                                        ) +
                                        parseFloat(
                                          item.post_delivery_charge || 0
                                        ) +
                                        parseFloat(item.shipping_cost || 0),
                                      0
                                    )
                                    .toLocaleString()}
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum + parseFloat(item.net_money || 0),
                                      0
                                    )
                                    .toLocaleString()}
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(item.total_withdrawn || 0),
                                      0
                                    )
                                    .toLocaleString()}
                                </td>
                                <td>
                                  {overviewData.fulfillments
                                    .reduce(
                                      (sum, item) =>
                                        sum +
                                        parseFloat(item.wallet_balance || 0),
                                      0
                                    )
                                    .toLocaleString()}
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              )}

            {/* No Data Message */}
            {(!overviewData?.fulfillments ||
              overviewData.fulfillments.length === 0) && (
              <div className="text-center py-5">
                <p className="text-muted">{_("panel.no_data_available")}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FulfilllmentRepost;
